import { render } from "./CardBody.vue?vue&type=template&id=963563b2"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/CardBody.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "963563b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('963563b2', __exports__)) {
    api.reload('963563b2', __exports__)
  }
  
  module.hot.accept("./CardBody.vue?vue&type=template&id=963563b2", () => {
    api.rerender('963563b2', render)
  })

}


export default __exports__